import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DialogService {
  private showDialog: Subject<any> = new Subject<any>();
  private feedBack: Subject<boolean>;

  openDialog(config: {
    headerText: string;
    detailText: string;
    dialogType: DialogType;
    warningText?: string;
    fullscreen?: boolean;
    zIndex?: number;
  }) {
    this.showDialog.next(config);
    this.feedBack = new Subject<boolean>();
    return this.feedBack.asObservable();
  }

  registerDialog() {
    return this.showDialog.asObservable();
  }

  dialogFeedback(feedback: boolean) {
    this.feedBack.next(feedback);
    this.feedBack.complete();
  }
}

export enum DialogType {
  Delete,
  Continue,
  YesNo,
}
